// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"a7db79b3","197":"f7753b99","212":"4af02abf","396":"07423149","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};